import type {
  IContentReportResponse,
  ICreateContentReportPayload,
} from "../types/content-report";
import type { ApiClient } from "./client";

const BASE_PATH = "/content-reports";

// NOTE: NSAI-5752 — one call, deliberately. Reporting is write-only from a
// client's point of view: a reporter files a report and is told it landed. What
// happens next is the organization owners' business, so there is no list, no
// status and no read endpoint here for an ordinary member to poll.
export class ContentReportApi {
  constructor(private apiClient: ApiClient) {}

  async createReport(
    payload: ICreateContentReportPayload,
  ): Promise<IContentReportResponse> {
    const response = await this.apiClient.post<IContentReportResponse>(
      BASE_PATH,
      payload,
    );

    return response.data;
  }
}
